
(function(){
  'use strict';
  var PAIRS={
    '15952346186112':{'15969739440512':4,'15952346087808':2},
    '15969739440512':{'15952346186112':4},
    '15952346087808':{'15952346186112':2}
  };
  // Render all amounts in the shopper's active market currency.
  function cleanId(x){return String(x||'').split('/').pop()}
  function price(x){var n=Number(x);return Number.isFinite(n)?n:0}
  function safeJSON(el, fallback){try{return JSON.parse(el.textContent)}catch(e){return fallback}}
  function origin(tags){if(tags.includes('japanese'))return 'Japanese';if(tags.includes('simplified-chinese'))return 'Simplified Chinese';if(tags.includes('english'))return 'English';return 'Pokémon TCG'}
  function pick(src,source){
    if(!src)return null;
    var variants=src.variants;
    if(source==='catalog')return {id:cleanId(src.id),title:src.title,url:src.url,image:src.image,price:price(src.price),variantId:cleanId(src.variantId),tags:src.tags||[],source:source,available:!!src.available,variantsCount:src.variantsCount||1};
    if(!Array.isArray(variants)||variants.length!==1)return null;
    var v=variants[0],img=src.featured_image||src.image||src.images&&src.images[0]||'';
    if(typeof img==='object')img=img.src||img.url||'';
    return {id:cleanId(src.id),title:src.title,url:src.url,image:img,price:price(v.price),variantId:cleanId(v.id),tags:Array.isArray(src.tags)?src.tags:[],source:source,available:!!src.available&&!!v.available,variantsCount:variants.length};
  }
  function tagMatch(a,b){var ignored=['pokemon','sealed','japanese','simplified-chinese','english','booster-box','single-pack','booster-pack','gift-box','collection-box','incoming-stock','new-arrival','supplier-details-unverified','pokemon-singles','pokemon-single','single-card','singles','test-listing'];return a.filter(t=>!ignored.includes(t)&&b.includes(t)).length}
  function element(tag,cls,text){var e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e}
  function init(root){
    if(root.dataset.fbtReady)return;
    root.dataset.fbtReady='1';
    var id=cleanId(root.dataset.productId),tags=(root.dataset.mainTags||'').split('|'),isSingle=root.dataset.mainType==='single';
    var format=new Intl.NumberFormat(document.documentElement.lang||'en-IE',{style:'currency',currency:root.dataset.currency||'EUR'});
    var variants=safeJSON(root.querySelector('[data-fbt-variants]'),[]);
    var catalog=safeJSON(root.querySelector('[data-fbt-catalog]'),[]);
    var line=root.querySelector('[data-fbt-items]'), add=root.querySelector('[data-fbt-add]'), total=root.querySelector('[data-fbt-total]');
    var cta=root.querySelector('[data-fbt-button]'),feedback=root.querySelector('[data-fbt-message]');
    var selected=[],currentVariant=null;
    var details=root.closest('.product-details')||document;
    function activeMain(){
      var field=details.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')||details.querySelector('form[action*="/cart/add"] input[name="id"]');
      var selectedId=cleanId(field&&field.value||variants[0]&&variants[0].id);
      return variants.find(v=>cleanId(v.id)===selectedId)||variants[0];
    }
    function quantity(){
      var input=details.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"]')||details.querySelector('input[name="quantity"]');
      var n=Number(input&&input.value||1);return Number.isSafeInteger(n)&&n>0&&n<=100? n:1;
    }
    function refresh(){
      currentVariant=activeMain();
      if(!currentVariant||!currentVariant.available||currentVariant.inventory_managed&&currentVariant.inventory<=0||price(currentVariant.price)<100){root.hidden=true;return}
      root.hidden=false;
      var n=quantity(),amount=price(currentVariant.price)*n;
      for(var i=0;i<selected.length;i++)if(selected[i].checked)amount+=selected[i].item.price;
      total.textContent=format.format(amount/100);
      var count=n+selected.filter(x=>x.checked).length;
      cta.textContent=selected.some(x=>x.checked)?'Add '+count+(count===1?' item':' items')+' to cart':'Select a pairing';
      add.disabled=!selected.some(x=>x.checked);
    }
    function row(item,isBase,label){
      var row=element('div',isBase?'pc-fbt__primary':'pc-fbt__addon');
      if(isBase)row.appendChild(element('span','pc-fbt__symbol','✓'));
      else {var wrapper=element('label','pc-fbt__check');var check=element('input');check.type='checkbox';check.setAttribute('aria-label','Include '+item.title);var mark=element('span','pc-fbt__check-mark');mark.setAttribute('aria-hidden','true');wrapper.appendChild(check);wrapper.appendChild(mark);check.addEventListener('change',function(){var found=selected.find(x=>x.item.id===item.id);if(found){found.checked=check.checked;refresh()}});row.appendChild(wrapper);item.check=check}
      var media=item.image?element('img','pc-fbt__image'):element('span','pc-fbt__placeholder','✦');
      if(item.image){media.src=item.image;media.alt='';media.loading='lazy';media.width=52;media.height=58}
      row.appendChild(media);
      var info=element('div','pc-fbt__info');
      var name=element(isBase?'span':'a','pc-fbt__name',item.title);
      if(!isBase)name.href=item.url||'#';
      info.appendChild(name);info.appendChild(element('span','pc-fbt__hint',label));
      row.appendChild(info);row.appendChild(element('strong','pc-fbt__cost',format.format(item.price/100)));
      return row;
    }
    function score(c){
      var match=PAIRS[id]&&PAIRS[id][c.id]||0;
      var points=(c.source==='complementary'?85:c.source==='related'?40:15)+match*65;
      if(origin(tags)===origin(c.tags))points+=21;
      points+=Math.min(tagMatch(tags,c.tags),4)*11;
      if(!isSingle&&tags.includes('single-pack')&&c.tags.includes('single-pack'))points+=10;
      if(!isSingle&&tags.includes('booster-box')&&c.tags.includes('booster-box'))points+=8;
      var main=price(variants[0]&&variants[0].price);
      if(main>0&&c.price>main*4)points-=35;
      return points;
    }
    function render(candidates){
      var filtered=candidates.map(c=>{c.score=score(c);return c}).sort((a,b)=>b.score-a.score).slice(0,2);
      if(!filtered.length){root.hidden=true;return}
      selected=filtered.map(item=>({item:item,checked:false}));
      var realPair=filtered.some(c=>PAIRS[id]&&PAIRS[id][c.id]>=2);
      root.querySelector('[data-fbt-title]').textContent=realPair?'Frequently bought together':'Complete your collection';
      root.querySelector('[data-fbt-eyebrow]').textContent=realPair?'BASED ON PULLCOVE ORDERS':'SMART COLLECTOR PAIRINGS';
      line.replaceChildren();
      line.appendChild(row({title:root.dataset.productTitle,image:root.dataset.mainImage,price:price(variants[0].price)},true,'Your current product · '+origin(tags)));
      filtered.forEach((item,i)=>line.appendChild(row(item,false,(PAIRS[id]&&PAIRS[id][item.id]>=2?'Bought together previously · ': 'Suggested pairing · ')+origin(item.tags))));
      refresh();
    }
    async function load(){
      var base=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
      if(base.slice(-1)!=='/')base+='/';
      var result=catalog.map(x=>pick(x,'catalog')).filter(Boolean);
      var endpoint=base+'recommendations/products.json?product_id='+encodeURIComponent(id)+'&limit=10&intent=';
      var requests=['complementary','related'].map(async function(intent){
        try{
          var response=await fetch(endpoint+intent,{credentials:'same-origin'});
          if(!response.ok)throw Error('recommendations unavailable');
          var data=await response.json();
          return (data.products||[]).map(p=>pick(p,intent)).filter(Boolean);
        }catch(e){return []}
      });
      var sets=await Promise.all(requests);
      var unique=new Map();
      for(var item of [].concat(sets[0],sets[1],result)){
        if(!item||!item.available||!item.variantId||item.id===id||item.price<100||!Array.isArray(item.tags)||item.tags.includes('POS-ONLY'))continue;
        var single=item.tags.includes('pokemon-single')||item.tags.includes('single-card');
        if(single!==isSingle)continue;
        var prior=unique.get(item.id);
        if(!prior||score(item)>score(prior))unique.set(item.id,item);
      }
      render([...unique.values()]);
    }
    add.addEventListener('click',async function(){
      if(add.disabled)return;
      currentVariant=activeMain();
      if(!currentVariant||!currentVariant.available||currentVariant.inventory_managed&&currentVariant.inventory<=0){feedback.textContent='Please choose an available product option.';return}
      var items=[{id:Number(cleanId(currentVariant.id)),quantity:quantity()}];
      for(var x of selected)if(x.checked)items.push({id:Number(x.item.variantId),quantity:1});
      feedback.textContent='';add.disabled=true;cta.textContent='Adding to bag…';
      var base=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
      if(base.slice(-1)!=='/')base+='/';
      try{
        var response=await fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
        var payload=await response.json();
        if(!response.ok)throw Error(payload.description||payload.message||'Some items could not be added.');
        window.location.assign(base+'cart');
      }catch(err){feedback.textContent=err.message||'Could not add the selected products. Please try again.';add.disabled=false;refresh()}
    });
    details.addEventListener('change',function(){setTimeout(refresh,0)});
    details.addEventListener('input',function(){setTimeout(refresh,0)});
    load();
  }
  function boot(){document.querySelectorAll('.pc-fbt').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();
